import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { BadgeCardContainer } from '@pandiafi/components'

import type { CoreDayReservableArea } from '../../../common/validations/contractDayReservableAreasSchema'
import { DayReservableAreaBadgeCard } from './DayReservableAreaBadgeCard'
import { DayReservableAreasLegends } from './DayReservableAreasLegends'

type GroupedAreas = {
  address: string
  buildingPartLocationDetails: string
  areas: CoreDayReservableArea[]
}

export const DayReservableAreasGroup: FC<{
  group: GroupedAreas
  onOpenArea: (area: CoreDayReservableArea) => void
  readonly?: boolean
}> = ({ group, onOpenArea, readonly = false }) => {
  const { t } = useTranslation('storage')

  return (
    <section className="mb-5">
      <h3 className="text-base md:text-lg font-medium mb-3">
        {t('view.storageUnit')} {group.buildingPartLocationDetails}
      </h3>

      <BadgeCardContainer layout="grid">
        {group.areas.map((area) => (
          <DayReservableAreaBadgeCard
            key={area.rentableHierarchyId}
            area={area}
            onOpen={!readonly ? onOpenArea : undefined}
          />
        ))}
      </BadgeCardContainer>

      {group.areas.length > 0 && <DayReservableAreasLegends />}

      {group.address && (
        <div className="mt-4 text-gray-500">{group.address}</div>
      )}
    </section>
  )
}
